import React, { useState } from "react";
import arrow from "../assets/kangaroo/arrow-cropped.svg";
import dropdownarrow from "../assets/kangaroo/dropdown-arrow.png";
import { Col, Container, Row } from "reactstrap";
import img1 from "../assets/kangaroo/sydney types.png";
import img2 from "../assets/kangaroo/tower types.png";
import img3 from "../assets/kangaroo/smthg clock tpes.png";
import img4 from "../assets/kangaroo/usa types.png";
import img5 from "../assets/kangaroo/canada types.png";
import Button from "../component/button/Button";
import "../Homepage/Component/Homepage.css";
import Select from "react-select/base";
import Dropdown from "../component/dropdown/Dropdown";
import selectbtn from "../assets/kangaroo/selectbtn.svg";
import { useNavigate } from "react-router-dom";
import Smallbutton from "../component/button/Smallbutton";
import Destinationcountry from "../services/Destinationcountry";
import { useQuery } from "@tanstack/react-query";

const DestinationSelect = ({ data }) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const router = useNavigate();
  const options = [
    { value: "Australia", label: "Australia" },
    { value: "New Zealand", label: "New Zealand" },
    { value: "United Kingdom", label: "United Kingdom" },
    { value: "USA", label: "USA" },
    { value: "Canada", label: "Canada" },
  ];

  const [isMobile, setIsMobile] = useState(window.innerWidth < 700); // threshold 700px

  


   const fetchDestinationData = async()=>{
    const response = await Destinationcountry.getList();
    return response
  }

    const {isPending, error, data: countryData} = useQuery({
    queryKey: ["countryData"],
    queryFn: fetchDestinationData,
  })

    const countryOptions =
  countryData
    ?.filter((item) => item.isActive)
    ?.map((item) => ({
      id: item.id,
      label: item.name,
      slug: item.slug,  // Add this line
    })) || [];

console.log("data",countryData)

  return (
    <div className="main-container">
      <Container fluid className="">
        <Row className="d-flex justify-content-start align-items-center">
          <Col md={12} lg={5} className="mb-4 mb-lg-0 p-0">
            <h1 className="text-start lh-1 mb-3 mb-md-4 mt-2 mt-sm-0 font-level-4 fw-normal">
              {data[0]?.heading}
            </h1>
            <p className="font-level-2 font-level-6">{data[0]?.description}</p>
          </Col>
          <Col lg={1}></Col>

          <Col
            md={12}
            lg={6}
            className="d-flex jusitfy-content-end align-items-end  pe-0"
          >
            <div className="discover-width ms-0 ms-lg-4  ">
              <div
                className="d-flex justify-content-between align-items-center"
                style={{ marginBottom: "3rem" }}
              >
                <img
                  src={img1}
                  alt="Australia"
                  style={{ width: "62px", height: "58px", marginTop: "8px" }}
                />
                <img
                  src={img2}
                  alt="New Zealand"
                  style={{ width: "58px", height: "58px" }}
                />
                <img
                  src={img3}
                  alt="UK"
                  style={{ width: "58px", height: "58px" }}
                />
                <img
                  src={img4}
                  alt="USA"
                  style={{ width: "58px", height: "58px" }}
                />
                <img
                  src={img5}
                  alt="Canada"
                  style={{ width: "59px", height: "58px" }}
                />
              </div>

              {/* <div style={{ position: "relative", width: "100%" }}>
  <select
    className="form-select form-box custom-dropdown mb-2 w-100 py-3"
    id="courseSelect"
    style={{
      appearance: "none",
      WebkitAppearance: "none",
      MozAppearance: "none",
      background: "#f1f1f5", // match your form-box
      border: "1px solid #ccc",
      borderRadius: "8px",
      padding: "0.75rem 2.5rem 0.75rem 1rem", // space for arrow
      fontSize: "1rem",
      color: "#7e1790",
      cursor: "pointer",
    }}
  >
    <option value="" disabled selected>
      Destination
    </option>
    <option value="Australia">Australia</option>
    <option value="New Zealand">New Zealand</option>
    <option value="United Kingdom">United Kingdom</option>
    <option value="USA">USA</option>
    <option value="Canada">Canada</option>
  </select>

  <img
    src={dropdownarrow}
    alt="dropdown arrow"
    style={{
      position: "absolute",
      right: "15px",
      top: "50%",
      transform: "translateY(-50%)",
      width: "18px",
      pointerEvents: "none",
    }}
  />
</div> */}
              <div className="felx flex-col gap-2" style={{ marginBottom: "3.2rem" }}>
                <Dropdown
                              items={countryOptions}
                              selectedItem={selectedItem}
                              setSelectedItem={setSelectedItem}
                              placeholder="Destination"
                              
                            />
              </div>

              {/* <Button
                label="SELECT"
                // width="15vw"
                width="235px"
                // width="clamp(11.25rem, 15vw, 14.6875rem)"
                height="70.8661px"
                // height="clamp(3.4375rem, 6vh, 4.4291rem)"
                // height="70.8861px"
                // margin="20px auto"
                // padding="10px"
                fontSize="clamp(1rem, 2vw, 1.375rem)"
                textColor="#890295"
                fontWeight="800"
                fontFamily="Proxima Nova Bold"
              /> */}
              <div className=" d-flex w-100 justify-content-start ">
                {/* <button
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  padding: 0,
                  position: "relative",
                  width: "235px",
                  height: "70px",
                  cursor: "pointer",
                }}
                className="mt-3"
                onClick={() => {
  if (selectedItem) {
    const formatted = selectedItem.label.toLowerCase().replace(/\s+/g, '');
    router(`/innerpage/${formatted}`);
  }
}}


              >
                <img
                  src={selectbtn}
                  alt=""
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "block",
                  }}
                />
              </button> */}
                <div className="justify-content-start"
                   onClick={() => router(`/study-abroad/${selectedItem?.slug}`)}
                >
             
                   <Smallbutton
                      width="210px"
                      height="clamp(55px, 15vw, 60px)"
                      textColor={data[0]?.buttonColor}
                      text={data[0]?.buttontext}
                      fontSize={23}
                     
                    />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DestinationSelect;
